import type { CSSProperties } from 'react';
import { C } from '../ChatAssistant/compact/tokens';
import { font as f } from '../ChatAssistant/compact/style';

/** 10px uppercase table header / caption text. */
export const TH: CSSProperties = { font: f(600, 10), letterSpacing: '.06em', textTransform: 'uppercase', color: C.muted };
/** Divider between table rows. */
export const ROW_LINE = `1px solid ${C.divider}`;
